import { map } from 'rxjs/operators';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { DataLogin } from './autenticacion.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const smartHomeUrl = 'https://as-ws-smarthome.azurewebsites.net/';
@Injectable({
  providedIn: 'root'
})
export class HeaderInfoService {

  constructor(private _http: HttpClient) { }

  public menuOculto = new BehaviorSubject(false);
  public soloBotonMenu = new BehaviorSubject(false);
  
  public tituloPagina = new BehaviorSubject('Lugares');
  public conjunto = new BehaviorSubject('');
  public tituloTarjeta = new BehaviorSubject('¡Bienvenido al perfil!');
  public textoTarjeta = new BehaviorSubject('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo.');
  public imagenTarjeta = new BehaviorSubject('./../../../../assets/header/pagina-principal-lugares.svg')
  public imagenUnidad = new BehaviorSubject('https://illustoon.com/photo/5414.png')

  public cambiarTituloPagina(nuevoTituloPagina: string): void {
    this.tituloPagina.next(nuevoTituloPagina);
  }

  public cambiarConjunto(nuevoConjunto: string): void {
    this.conjunto.next(nuevoConjunto);
  }

  public cambiarTituloTarjeta(nuevoTituloTarjeta: string): void {
    this.tituloTarjeta.next(nuevoTituloTarjeta);
  }

  public cambiarTextoTarjeta(nuevoTextoTarjeta: string): void {
    this.textoTarjeta.next(nuevoTextoTarjeta);
  }

  public cambiarImagenTarjeta(nuevaImagenTarjeta: string): void {
    this.imagenTarjeta.next(nuevaImagenTarjeta);
  }
  
  public cambiarImagenUnidad(nuevaImagenUnidad: string): void {
    this.imagenUnidad.next(nuevaImagenUnidad);
  }

  public toggleMenu(): void {
    this.menuOculto.next(!this.menuOculto.value);
  }

  public dejarSoloBotonMenu(nuevoValor: boolean): void {
    this.soloBotonMenu.next(nuevoValor);
  }

  traerDatosPerfil() {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    const requestUrl = `https://as-ws-siteit-test.azurewebsites.net/api/users/profileweb/${loginData.user_id}`;

    const headers = new HttpHeaders({
      info: 'true',
      type: 'user'
    });
    
    return this._http.get(requestUrl, { headers })
      .pipe(
        map((res: any) => {
          this.cambiarConjunto(res.response.company.name);
          this.cambiarImagenUnidad(res.response.company.picture);
          return res;
        })
      );
  }
}

export interface DataUnidad {
  data_unidad: UnidadResidencial;
}

export interface UnidadResidencial {
  id: number;
  business_name: string;
  name: string;
  address: string;
  phone: string;
}
